<template>
    <div class="login-box">
      <img class="logo" src="../assets/logo.png" alt="Logo" />
      <p class="text-h5 my-3">Login</p>
      <v-text-field v-model="email" label="Email" type="email" required></v-text-field>
      <v-text-field v-model="password" label="Password" type="password" required></v-text-field>
      <v-btn class="mt-2" @click="login" :loading="loading">
        {{ loading ? 'Logging in...' : 'Login' }}
      </v-btn>
      <p v-if="error" class="error-message">{{ error }}</p>
      <p class="mt-3 text-decoration-underline text-blue cursor-pointer" @click="handleForgotPassword">
        Forgot password?
      </p>
    </div>
  </template>
  
  <script>
  import firebaseconfig from '../../firebase.config';
  import { signInWithEmailAndPassword } from 'firebase/auth';
  
  export default {
    data() {
      return {
        email: '',
        password: '',
        error: null,
        loading: false,
      };
    },
    methods: {
      async login() {
        this.error = null;
        this.loading = true;
        try {
          const userCredential = await signInWithEmailAndPassword(
            firebaseconfig.auth,
            this.email,
            this.password
          );
          this.$emit('currentUser', userCredential.user);
        } catch (error) {
          console.error(error);
          this.error = error.message;
        } finally {
          this.loading = false;
        }
      },
      handleForgotPassword() {
        console.log('Forgot password clicked');
      },
    },
  };
  </script>
  
  <style scoped>
  .login-box {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    display: grid;
    justify-content: center;
    background-color: lightgray;
    padding: 30px;
    border-radius: 10px;
    width: 300px; /* or whatever width suits your design */
  }
  
  .logo {
    margin: 0;
  }
  
  .error-message {
    color: red;
    margin-top: 10px;
  }
  </style>